import { documentationActions } from '../../actions/constant';

const { SUCCESS_GET_ALL_CODES, FAILURE_GET_ALL_CODES, LOADING_GET_ALL_CODES } =
  documentationActions;

const intitialstate: object = {
  response: null,
  areGettingCodes: false,
  loading: false,
};

export const getAllCodeReducers = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_CODES: {
      return {
        ...state,
        areGettingCodes: true,
        response: action.payload,
        loading: false,
      };
    }

    case FAILURE_GET_ALL_CODES:
      return {
        ...state,
        areGettingCodes: false,
        response: action.payload,
        loading: true,
      };

    case LOADING_GET_ALL_CODES:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
